import { DossierSearchCriteria, TrainType } from '@app/pcs/models';
import {
  AdvancedSearchForm, AGENCY_INVOLVEMENT,
  INVOLVED_AGENCY_TRAFFIC_LIGHT_PAIRS,
  MY_PROGRESS_STATUSES, TRAIN_TYPES
} from '@app/pcs/reducer/advanced-search/search-form';
import { getControlValue, hasValue } from '@util';
import { FormGroupState, unbox } from 'ngrx-forms';
import * as R from 'ramda';

export const getLabelForKey = R.cond([
  [R.equals('dossierName'), R.always('general.label.dossier.name')],
  [R.equals('dossierRoute'), R.always('general.label.dossier.route')],
  [R.equals('cataloguePathNumber'), R.always('label.dossier.catalogue.path.number')],
  [R.equals('trainNumber'), R.always('general.label.train.number')],
  [R.equals('labels'), R.always('label.labels')],
  [R.equals(TRAIN_TYPES), R.always('general.label.train.type')],
  [R.equals('dossierType'), R.always('general.label.dossier.type')],
  [R.equals('operationPoints'), R.always('general.label.stop')],
  [R.equals('rfcCorridor'), R.always('label.rfc.corridor')],
  [R.equals('phaseGroup'), R.always('label.dossier.phase.group')],
  [R.equals('involvedAgencies'), R.always('general.label.participants')],
  [R.equals(MY_PROGRESS_STATUSES), R.always('dossiersearch.myAccIndicator')],
  [R.equals('progressStatuses'), R.always('general.label.acceptance.indicator')],
  [R.equals(INVOLVED_AGENCY_TRAFFIC_LIGHT_PAIRS), R.always('dossiersearch.participantsAndIndicators')],
  [R.equals(AGENCY_INVOLVEMENT), R.always('my.company.involvement')]
]);

const setTrainTypes = (searchCriteria, trainTypes) => R.mergeDeepRight(searchCriteria, {
  trainTypes
});

type GetTrainTypes = (searchCriteria: DossierSearchCriteria) =>  TrainType[];
const getTrainTypes: GetTrainTypes = (searchCriteria: DossierSearchCriteria) => R.prop(TRAIN_TYPES, searchCriteria);

type ResolveTrainType = (searchCriteria: DossierSearchCriteria) => DossierSearchCriteria;
const resolveTrainTypes: ResolveTrainType = (searchCriteria) => {
  const trainTypes = getTrainTypes(searchCriteria);

  return hasValue(trainTypes)
    ? setTrainTypes(searchCriteria, trainTypes)
    : searchCriteria;
};

type OmitFields = (searchCriteria: DossierSearchCriteria) => DossierSearchCriteria;
const omitFields = <OmitFields>R.evolve({
  phaseGroup: R.ifElse(hasValue, R.omit(['dossierStatuses']), R.identity)
});

type PrepareForm = (form: FormGroupState<AdvancedSearchForm>) => DossierSearchCriteria;
export const prepareAdvancedSearchForm = <PrepareForm>R.compose(omitFields, resolveTrainTypes, unbox, getControlValue);
